(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["find-a-dealer"]) return;
  try {
    
  var dealerMarkers = {};
  var bounceTimeout = null;
  var userLocation = null;
  var userMarker = null;
  // 半径由网关配置统一控制（接口返回 radius_km），前端只上报坐标
  var DEALER_PROXY_PATH = '/apps/gateway/dealers/near';
  var nearCount = 0;
  var nearRadius = 0; // 0=尚未从后端取得实际半径（定位成功后由响应赋值）
  var nearMaxRadius = 200;
  var sliderRadius = 0; // 用户拖动选择的半径；0=未选择（用默认）
  var nearTruncated = false;

  window.initDealerMap = function () {
    var container = document.getElementById('dealer-map');
    if (!container || !window.google || !window.google.maps) return;

    // 地图每次重建，旧的用户标记引用一并清空（marker 随旧 map 丢弃）
    userMarker = null;

    var centerLat, centerLng, centerZoom;
    if (userLocation) {
      centerLat = userLocation.lat;
      centerLng = userLocation.lng;
      centerZoom = 10;
    } else {
      centerLat = parseFloat(container.dataset.centerLat) || 54.5;
      centerLng = parseFloat(container.dataset.centerLng) || -2.5;
      centerZoom = 6;
    }

    var map = new google.maps.Map(container, {
      center: { lat: centerLat, lng: centerLng },
      zoom: centerZoom,
      streetViewControl: false,
      fullscreenControl: true,
    });

    // 容器尺寸变化（窗口缩放 / 主题编辑器切换预览尺寸）时通知地图重新渲染：
    // 否则 Google 画布尺寸滞后于容器，会溢出容器压住下方区块（外层已用 overflow:hidden 兜底）。
    if (window.google && google.maps && google.maps.event) {
      window.addEventListener('resize', function () {
        google.maps.event.trigger(map, 'resize');
      });
    }

    var infoWindow = new google.maps.InfoWindow();
    var cards = document.querySelectorAll('.dealer-card');

    function highlight(card) {
      document
        .querySelectorAll('.dealer-card--active')
        .forEach(function (c) { c.classList.remove('dealer-card--active'); });
      card.classList.add('dealer-card--active');
    }

    function openDealer(card, marker) {
      var lat = parseFloat(card.dataset.lat);
      var lng = parseFloat(card.dataset.lng);
      if (!lat || !lng) return;

      map.panTo({ lat: lat, lng: lng });
      map.setZoom(14);

      var popup = card.querySelector('.dealer-card__popup');
      // innerHTML 不含外壳 div，重新包一层让 .dealer-card__popup 的颜色/字号规则在 InfoWindow 里生效
      infoWindow.setContent(popup ? '<div class="dealer-card__popup">' + popup.innerHTML + '</div>' : card.dataset.name);
      infoWindow.open(map, marker);

      // Google 打开 InfoWindow 时会自动把焦点移入弹窗内容（无障碍标准行为），
      // 这种非指针聚焦会被判定为 :focus-visible，让链接凭空出现焦点框。
      // 主动释放该自动焦点；键盘用户仍可用 Tab 进入（此时才显示低调焦点环）。
      releasePopupAutoFocus();

      // 移动端为单列布局（地图在列表上方）：点击卡片后把视口滚到地图，
      // 否则定位/弹窗发生在屏幕外，用户看不到反馈。桌面端地图与列表同屏，不滚动。
      // 抽屉形态下同时收起侧边栏，让地图与弹窗完整露出（桌面端空操作）。
      closeDealerDrawer();
      scrollMapIntoView();

      highlight(card);

      // 点击 dealer：地图标点在选中位置跳动 3 秒后停止
      if (marker && window.google && google.maps && google.maps.Animation) {
        for (var mid in dealerMarkers) {
          if (dealerMarkers[mid]) dealerMarkers[mid].setAnimation(null);
        }
        marker.setAnimation(google.maps.Animation.BOUNCE);
        if (bounceTimeout) clearTimeout(bounceTimeout);
        bounceTimeout = setTimeout(function () {
          marker.setAnimation(null);
        }, 3000);
      }
    }

    cards.forEach(function (card) {
      var lat = parseFloat(card.dataset.lat);
      var lng = parseFloat(card.dataset.lng);
      if (!lat || !lng) return;

      var marker = new google.maps.Marker({
        position: { lat: lat, lng: lng },
        map: map,
        title: card.dataset.name,
      });
      dealerMarkers[card.dataset.id] = marker;

      marker.addListener('click', function () { openDealer(card, marker); });
      card.addEventListener('click', function () { openDealer(card, marker); });
    });

    addUserMarker(map, infoWindow);
  };

  // addUserMarker 在地图上标记「我的位置」：Google 风格蓝点（与经销商标红大头针区分），
  // 点击提示 You are here；同时在地图右上角挂「回到我的位置」按钮。
  // 不参与列表搜索过滤（applyFilter 只控制 dealerMarkers）。
  function addUserMarker(map, infoWindow) {
    if (!userLocation || !window.google || !google.maps) return;
    var userLatLng = { lat: userLocation.lat, lng: userLocation.lng };

    userMarker = new google.maps.Marker({
      position: userLatLng,
      map: map,
      title: 'You are here',
      zIndex: 999,
      clickable: true,
      icon: {
        path: 'M 0,0 m -6,0 a 6,6 0 1,1 12,0 a 6,6 0 1,1 -12,0',
        fillColor: '#4285F4',
        fillOpacity: 1,
        scale: 1.2,
        strokeColor: '#ffffff',
        strokeWeight: 2.5,
      },
    });

    userMarker.addListener('click', function () {
      infoWindow.setContent('<div class="dealer-card__popup"><strong>You are here</strong></div>');
      infoWindow.setPosition(userLatLng);
      infoWindow.open(map);
    });

    addLocateControl(map);
  }

  // relocate 重新请求浏览器定位：成功后更新蓝点位置并重新拉取附近经销商
  // （fetchNearby 会重建列表与地图，蓝点随新位置重建）；失败保持现状不打断页面。
  function relocate() {
    if (!navigator.geolocation) return;
    navigator.geolocation.getCurrentPosition(
      function (pos) {
        userLocation = {
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
          accuracy: pos.coords.accuracy,
        };
        fetchNearby(userLocation.lat, userLocation.lng, sliderRadius || undefined);
      },
      function () { /* 定位失败：保留上次结果，不打断当前视图 */ },
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
    );
  }

  // addLocateControl 地图右上角「重新定位」按钮：重新获取当前位置并刷新附近经销商
  function addLocateControl(map) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'dealer-map__locate';
    btn.setAttribute('aria-label', 'Relocate to me');
    btn.title = 'Relocate to me';
    btn.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" fill="#4285F4">'
      + '<path d="M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8zm8.94 3a9 9 0 0 0-7.93-7.93V1h-2.02v2.07A9 9 0 0 0 3.07 11H1v2.02h2.07a9 9 0 0 0 7.92 7.92V23h2.02v-2.06a9 9 0 0 0 7.92-7.92H23V11h-2.06zM12 19a7 7 0 1 1 0-14 7 7 0 0 1 0 14z"></path></svg>';
    btn.addEventListener('click', function () {
      // 有缓存位置先平移过去（立即反馈），随后重新定位刷新
      if (userLocation) {
        map.panTo({ lat: userLocation.lat, lng: userLocation.lng });
        map.setZoom(12);
      }
      relocate();
    });
    map.controls[google.maps.ControlPosition.TOP_RIGHT].push(btn);
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  function nl2br(s) {
    return escapeHtml(s).replace(/\r?\n/g, '<br>');
  }

  // 定位成功后经 App Proxy 拉取附近经销商（半径由网关钳制，超出滑轨上限按上限计算），再动态渲染
  function fetchNearby(lat, lng, radius) {
    var qs = '?lat=' + encodeURIComponent(lat) + '&lng=' + encodeURIComponent(lng);
    if (radius && radius > 0) qs += '&radius=' + encodeURIComponent(radius);
    fetch(DEALER_PROXY_PATH + qs, {
      headers: { Accept: 'application/json' },
    })
      .then(function (resp) {
        if (!resp.ok) throw new Error('HTTP ' + resp.status);
        return resp.json();
      })
      .then(function (body) {
        if (!body || body.code !== 0 || !body.data) {
          throw new Error((body && body.message) || '接口返回异常');
        }
        nearCount = body.data.count || 0;
        nearRadius = body.data.radius_km || nearRadius;
        // 滑轨上限必须从响应同步（后台"前台滑轨上限"设置的来源）——
        // 曾漏掉此赋值导致 nearMaxRadius 永远是初始值 200，后台设置上限不生效
        nearMaxRadius = body.data.max_radius_km || nearMaxRadius;
        nearTruncated = !!body.data.truncated;
        renderDealers(body.data.dealers || []);
        showLayout();
        updateNearCount();
        // 用后端返回的实际生效半径初始化滑轨（此前该调用缺失，导致滑轨一直显示 HTML 占位值）
        setupRadiusSlider();
        loadDealerMap();
      })
      .catch(function (err) {
        // 失败必须留原始错误：接口失败 vs 渲染抛异常（如字段缺失）表现相同，没日志分不清
        console.error('[find-a-dealer] load nearby failed:', err);
        showGateMsg('Failed to load nearby dealers. Please try again.', true);
      });
  }

  function renderDealers(dealers) {
    var list = document.getElementById('dealer-list');
    if (!list) return;
    dealerMarkers = {};

    if (!dealers.length) {
      list.innerHTML = '<p class="find-a-dealer__empty">No dealers within ' + nearRadius + ' km.</p>';
      return;
    }

    var phoneSvg = '<svg viewBox="0 0 24 24" width="13" height="13" fill="#d0342c"><path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.6 21 3 13.4 3 4c0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.2.2 2.4.6 3.6.1.3 0 .7-.2 1l-2.3 2.2z"></path></svg>';
    var mailSvg = '<svg viewBox="0 0 24 24" width="13" height="13" fill="#d0342c"><path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5-8-5V6l8 5 8-5v2z"></path></svg>';
    var globeSvg = '<svg viewBox="0 0 24 24" width="13" height="13" fill="#d0342c"><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95a15.65 15.65 0 0 0-1.38-3.56A8.03 8.03 0 0 1 18.92 8zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2s.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56A7.987 7.987 0 0 1 5.08 16zm2.95-8H5.08a7.987 7.987 0 0 1 4.33-3.56A15.65 15.65 0 0 0 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2s.07-1.35.16-2h4.68c.09.65.16 1.32.16 2s-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95a8.03 8.03 0 0 1-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2s-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z"></path></svg>';

    // 官网链接安全检查：只放行 http/https（后端已归一化，此处防御纵深拒绝 javascript: 等）。
    // 注意：本函数不依赖 d，必须放在 map 回调外；单条经销商的 websiteUrl/websiteHost
    // 在下方 map 回调里计算（引用回调参数 d）——曾错放到回调外导致 ReferenceError，
    // 被 fetchNearby 的 catch 吞成 "Failed to load nearby dealers"、地图永不初始化。
    var safeWebsiteUrl = function (u) {
      var s = String(u || '').trim();
      return /^https?:\/\//i.test(s) ? s : '';
    };

    var html = dealers.map(function (d, i) {
      var lat = d.latitude, lng = d.longitude;
      var search = ((d.name || '') + ' ' + (d.address || '')).toLowerCase();
      // 官网链接：展示文本用主机名（去协议、去路径），新标签页打开
      var websiteUrl = safeWebsiteUrl(d.website);
      var websiteHost = websiteUrl
        ? websiteUrl.replace(/^https?:\/\//i, '').replace(/[\/?#].*$/, '')
        : '';
      // 导航链接：有 Place ID 时精确锚定门店 POI，否则退回坐标
      // 点击打开 Google 门店信息页（地点详情：名称/照片/营业信息，页内自带导航入口），
      // 而非直接进入路线规划；有 Place ID 时精确锚定该门店，否则用「店名 + 地址」文字搜索。
      var storeName = (d.name || '').trim();
      var query = (storeName + ' ' + (d.address || '')).trim() || (lat + ',' + lng);
      var infoUrl = 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(query);
      if (d.place_id) infoUrl += '&query_place_id=' + encodeURIComponent(d.place_id);
      // 门店照片：有图才渲染（无图不留图片位；加载失败自动移除，同样不留空位）
      var photo = d.image_url
        ? '<img class="dealer-card__photo" src="' + escapeHtml(d.image_url) + '" alt="' + escapeHtml(d.name)
          + '" loading="lazy" onerror="this.remove()">'
        : '';
      var popupPhoto = d.image_url
        ? '<img class="dealer-card__popup-photo" src="' + escapeHtml(d.image_url) + '" alt="' + escapeHtml(d.name)
          + '" loading="lazy" onerror="this.remove()">'
        : '';
      return ''
        + '<article class="dealer-card" data-id="' + escapeHtml(d.handle) + '" data-name="' + escapeHtml(d.name) + '"'
        + ' data-lat="' + lat + '" data-lng="' + lng + '" data-search="' + escapeHtml(search) + '">'
        + '<div class="dealer-card__badge">' + (i + 1) + '</div>'
        + photo
        + '<div class="dealer-card__body">'
        + '<h3 class="dealer-card__name">' + escapeHtml(d.name) + '</h3>'
        + (d.address ? '<p class="dealer-card__address">' + nl2br(d.address) + '</p>' : '')
        + (d.phone ? '<p class="dealer-card__phone">' + phoneSvg + '<span>' + escapeHtml(d.phone) + '</span></p>' : '')
        + (d.email ? '<p class="dealer-card__email">' + mailSvg + '<span>' + escapeHtml(d.email) + '</span></p>' : '')
        + (websiteUrl ? '<a class="dealer-card__website" href="' + escapeHtml(websiteUrl) + '" target="_blank" rel="noopener noreferrer" onclick="event.stopPropagation()">' + globeSvg + '<span>' + escapeHtml(websiteHost) + '</span></a>' : '')
        + '<a class="dealer-card__directions" href="' + infoUrl + '" target="_blank" rel="noopener">View Store Info ›</a>'
        + '</div>'
        + '<div class="dealer-card__popup" hidden>'
        + '<div class="dealer-card__popup-main">'
        + popupPhoto
        + '<div class="dealer-card__popup-info">'
        + '<strong>' + escapeHtml(d.name) + '</strong><br>'
        + (d.address ? nl2br(d.address) + '<br>' : '')
        + (d.phone ? escapeHtml(d.phone) + '<br>' : '')
        + (d.email ? escapeHtml(d.email) + '<br>' : '')
        + (websiteUrl ? '<a class="dealer-card__popup-website" href="' + escapeHtml(websiteUrl) + '" target="_blank" rel="noopener noreferrer">' + escapeHtml(websiteHost) + '</a><br>' : '')
        + '<a class="dealer-card__popup-directions" href="' + infoUrl + '" target="_blank" rel="noopener">View Store Info ›</a>'
        + '</div></div>'
        + '</div>'
        + '</article>';
    }).join('');
    list.innerHTML = html;
    applySearchFilter();
  }

  function updateNearCount() {
    var el = document.getElementById('dealer-near');
    if (!el) return;
    if (!userLocation) { el.hidden = true; return; }
    el.hidden = false;
    el.textContent = nearTruncated
      ? 'Showing nearest ' + nearCount + ' dealers within ' + nearRadius + ' km'
      : nearCount + ' dealers within ' + nearRadius + ' km';
  }

  function showGateMsg(text, withRetry) {
    var layout = document.querySelector('.find-a-dealer__layout');
    var gate = document.querySelector('.find-a-dealer__gate');
    var gateText = document.getElementById('dealer-gate-text');
    var retryBtn = document.getElementById('dealer-locate-retry');
    // 门控态（未定位成功）隐藏抽屉开关并收起抽屉：列表内容为空，浮动按钮只会造成困惑
    var drawerToggle = document.getElementById('dealer-drawer-toggle');
    if (drawerToggle) drawerToggle.style.display = 'none';
    closeDealerDrawer();
    if (layout) layout.style.display = 'none';
    if (gate) gate.style.display = 'flex';
    if (gateText) gateText.textContent = text;
    if (retryBtn) retryBtn.style.display = withRetry ? '' : 'none';
  }

  function showLayout() {
    var layout = document.querySelector('.find-a-dealer__layout');
    var gate = document.querySelector('.find-a-dealer__gate');
    // 恢复抽屉开关（inline 置空后交回 CSS：桌面端 display:none、移动端显示）
    var drawerToggle = document.getElementById('dealer-drawer-toggle');
    if (drawerToggle) drawerToggle.style.display = '';
    if (layout) layout.style.display = '';
    if (gate) gate.style.display = 'none';
  }

  function requestLocation() {
    showGateMsg('Getting your location…', false);
    if (!navigator.geolocation) {
      showGateMsg('Please allow location access to see dealers near you.', true);
      return;
    }
    navigator.geolocation.getCurrentPosition(
      function (pos) {
        userLocation = {
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
          accuracy: pos.coords.accuracy,
        };
        fetchNearby(userLocation.lat, userLocation.lng);
      },
      function () {
        showGateMsg('Please allow location access to see dealers near you.', true);
      },
      { enableHighAccuracy: false, timeout: 10000, maximumAge: 600000 }
    );
  }

  // setupRadiusSlider 用后端返回的实际生效半径初始化滑轨（位置/文案/计数三者一致）。
  // 不再依赖 userLocation 判空（首次自动定位路径下曾导致不显示），
  // 只要拿到半径数据就显示，并强制把滑轨值同步为后端半径（而非 HTML 里的占位值）。
  function setupRadiusSlider() {
    var row = document.getElementById('dealer-radius-row');
    var slider = document.getElementById('dealer-radius');
    var val = document.getElementById('dealer-radius-val');
    if (!row || !slider || !val) return;
    if (!nearRadius || nearRadius <= 0) return; // 尚无半径数据（未定位成功）时不显示
    var max = Number(nearMaxRadius) > 0 ? Number(nearMaxRadius) : 200;
    row.hidden = false;
    slider.max = String(max);
    slider.value = String(Math.min(Math.max(1, nearRadius), max));
    sliderRadius = Number(slider.value);
    val.textContent = sliderRadius + ' km';
  }

  // 表单格式校验（与后端一致）：邮箱标准格式；手机号仅数字 + - ( ) 与空格，至少 6 位数字
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var PHONE_RE = /^[0-9+\-() ]{6,20}$/;

  // 字段标签（报错时指明是哪个字段，便于访客定位）
  var FIELD_LABELS = {
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    address: 'Address',
    shop_name: 'Shop name',
    shop_contact: 'Shop contact',
    shop_email: 'Shop email',
    shop_phone: 'Shop phone',
  };

  function fieldLabel(key) {
    return FIELD_LABELS[key] || key;
  }

  function validPhone(v) {
    var s = (v || '').trim();
    if (!s) return true; // 选填
    if (!PHONE_RE.test(s)) return false;
    return (s.match(/[0-9]/g) || []).length >= 6;
  }

  // scrollMapIntoView 仅移动端（单列布局）把视口平滑滚动到地图区域，
  // 让用户点卡片后能立刻看到地图定位与信息弹窗；桌面端双列同屏，不做滚动。
  function scrollMapIntoView() {
    if (!window.matchMedia || !window.matchMedia('(max-width: 768px)').matches) return;
    var mapEl = document.querySelector('.find-a-dealer__map');
    if (!mapEl) return;
    // 预留头部/导航高度，避免滚动后地图顶部被 sticky 头部遮挡
    var headerOffset = 70;
    var top = mapEl.getBoundingClientRect().top + window.pageYOffset - headerOffset;
    if (window.scrollTo) {
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    } else {
      window.scrollTo(0, Math.max(0, top));
    }
  }

  // releasePopupAutoFocus 释放 Google InfoWindow 自动获取的焦点。
  // 不做此事时，弹窗内的入口链接会以 keyboard 方式聚焦并显示焦点环（用户观感＝凭空多一圈边框）。
  // 判断依据是「当前焦点是否落在我们的弹窗入口链接上」，不依赖 Google 内部类名，避免版本变动失效。
  function releasePopupAutoFocus() {
    [0, 60].forEach(function (delay) {
      setTimeout(function () {
        var el = document.activeElement;
        if (!el || typeof el.blur !== 'function' || !el.classList) return;
        var isPopupLink = el.classList.contains('dealer-card__popup-directions') ||
          el.classList.contains('dealer-card__directions');
        if (isPopupLink) el.blur();
      }, delay);
    });
  }

  // applySearchFilter 纯前端过滤：只按关键词筛当前列表，不发后端请求。
  // 每次调用实时取卡片（列表为异步渲染，绑定时的 NodeList 会过期）。
  function applySearchFilter() {
    var input = document.getElementById('dealer-search');
    if (!input) return;
    var q = (input.value || '').trim().toLowerCase();
    document.querySelectorAll('.dealer-card').forEach(function (card) {
      var show = !q || (card.dataset.search || '').indexOf(q) !== -1;
      card.style.display = show ? '' : 'none';
      var marker = dealerMarkers[card.dataset.id];
      if (marker) marker.setVisible(show);
    });
  }

  // ===== 移动端商家信息抽屉（右侧滑出）=====
  // 仅 ≤768px 生效（CSS 媒体查询控制显示）；桌面端元素 display:none，逻辑空转。
  function dealerDrawerSet(open) {
    var side = document.getElementById('dealer-side-drawer');
    var backdrop = document.getElementById('dealer-drawer-backdrop');
    var toggle = document.getElementById('dealer-drawer-toggle');
    if (!side) return;
    side.classList.toggle('is-open', open);
    if (backdrop) backdrop.classList.toggle('is-open', open);
    // 展开期间锁定页面滚动（防穿透），收起或视口切回桌面时解除
    document.body.classList.toggle('dealer-drawer-lock', open);
    if (toggle) {
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      // 展开时隐藏右上图钉按钮，避免与抽屉内容重叠造成双重入口
      toggle.classList.toggle('is-hidden', open);
      // 打开过一次就加 is-seen：CSS 脉冲提醒动画靠 :not(.is-seen) 命中，此后永久停止
      if (open) toggle.classList.add('is-seen');
    }
  }

  function closeDealerDrawer() {
    dealerDrawerSet(false);
  }

  function setupDealerDrawer() {
    var toggle = document.getElementById('dealer-drawer-toggle');
    var backdrop = document.getElementById('dealer-drawer-backdrop');
    var closeBtn = document.getElementById('dealer-drawer-close');
    if (toggle) {
      toggle.addEventListener('click', function () { dealerDrawerSet(true); });
    }
    if (backdrop) {
      backdrop.addEventListener('click', closeDealerDrawer);
    }
    if (closeBtn) {
      closeBtn.addEventListener('click', closeDealerDrawer);
    }
    // Escape 收起（桌面无影响，键盘用户友好）
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDealerDrawer();
    });
    // 视口切回桌面时复位状态，避免残留在展开态
    if (window.matchMedia) {
      var mq = window.matchMedia('(max-width: 768px)');
      var onChange = function (ev) { if (!ev.matches) dealerDrawerSet(false); };
      if (mq.addEventListener) mq.addEventListener('change', onChange);
      else if (mq.addListener) mq.addListener(onChange);
    }
  }

  function setupDealerUI() {
    var searchInput = document.getElementById('dealer-search');
    var viewAllBtn = document.getElementById('dealer-viewall');
    var list = document.getElementById('dealer-list');

    if (searchInput) searchInput.addEventListener('input', applySearchFilter);
    if (viewAllBtn) {
      viewAllBtn.addEventListener('click', function () {
        searchInput.value = '';
        applySearchFilter();
        if (list) list.scrollTop = 0;
      });
    }

    var retryBtn = document.getElementById('dealer-locate-retry');
    if (retryBtn) retryBtn.addEventListener('click', requestLocation);

    var slider = document.getElementById('dealer-radius');
    var sliderVal = document.getElementById('dealer-radius-val');
    if (slider) {
      slider.addEventListener('input', function () {
        sliderRadius = Number(slider.value) || 0;
        if (sliderVal) sliderVal.textContent = sliderRadius + ' km';
      });
      slider.addEventListener('change', function () {
        if (userLocation) fetchNearby(userLocation.lat, userLocation.lng, sliderRadius);
      });
    }

    // 引导表单：提交到 /apps/gateway/dealers/lead（App Proxy 自动签名）
    document.querySelectorAll('.find-a-dealer__lead-form').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var msg = form.querySelector('.find-a-dealer__lead-msg');
        var btn = form.querySelector('.find-a-dealer__lead-submit');
        // 统一提示：错误红色、成功绿色，居中（见 .find-a-dealer__lead-msg）
        var showMsg = function (text, ok) {
          msg.textContent = text;
          msg.style.color = ok ? '#1d9e75' : '#d0342c';
          msg.hidden = false;
        };
        var get = function (n) { var el = form.querySelector('[name=' + n + ']'); return el ? el.value.trim() : ''; };
        var data = {
          type: get('type'),
          name: get('name'),
          email: get('email'),
          phone: get('phone'),
          address: get('address'),
          shop_name: get('shop_name'),
          shop_contact: get('shop_contact'),
          shop_email: get('shop_email'),
          shop_phone: get('shop_phone'),
          remark: get('remark'),
          website: get('website'),
        };
        var required = (form.dataset.required || '').split(',').filter(Boolean);
        var missing = required.filter(function (n) { return !data[n]; });
        if (missing.length) {
          showMsg('Please complete: ' + missing.map(fieldLabel).join(', ') + '.');
          return;
        }
        // 格式校验（与后端口径一致）：选填项填写时才校验；提示只说项目，不暴露字段名
        if (data.email && !EMAIL_RE.test(data.email)) {
          showMsg('Please enter a valid email address.');
          return;
        }
        if (data.shop_email && !EMAIL_RE.test(data.shop_email)) {
          showMsg('Please enter a valid shop email address.');
          return;
        }
        if (!validPhone(data.phone)) {
          showMsg('Please enter a valid phone number.');
          return;
        }
        if (!validPhone(data.shop_phone)) {
          showMsg('Please enter a valid shop phone number.');
          return;
        }
        btn.disabled = true;
        msg.hidden = true;
        fetch('/apps/gateway/dealers/lead', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(data),
        })
          .then(function (resp) {
            return resp.json().then(function (body) { return { ok: resp.ok && body && body.code === 0, body: body }; });
          })
          .then(function (r) {
            btn.disabled = false;
            if (r.ok) {
              showMsg("Thanks! Your submission has been received. We'll get back to you soon.", true);
              form.reset();
            } else {
              showMsg((r.body && r.body.message) || 'Submission failed. Please try again.');
            }
          })
          .catch(function () {
            btn.disabled = false;
            showMsg('Submission failed. Please try again.');
          });
      });
    });
  }

  function loadDealerMap() {
    var container = document.getElementById('dealer-map');
    if (!container) return;

    var apiKey = container.dataset.apiKey;
    if (window.google && window.google.maps) {
      window.initDealerMap();
      return;
    }

    if (apiKey) {
      var script = document.createElement('script');
      script.src =
        'https://maps.googleapis.com/maps/api/js?key=' +
        encodeURIComponent(apiKey) +
        '&callback=initDealerMap';
      script.async = true;
      document.head.appendChild(script);
    } else {
      container.innerHTML = '<p style="padding:24px">Google Maps API key is not configured.</p>';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setupDealerUI();
      setupDealerDrawer();
      requestLocation();
    });
  } else {
    setupDealerUI();
    setupDealerDrawer();
    requestLocation();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
